import Route from 'mewe/routes/route';

export default class Error401Route extends Route {
  redirect() {
    document.body.classList.add('error-page');
  }
}
